import API from "@/api/lib/api";

export const getAllStandardFoods = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/standard-foods`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleStandardFood = async (item_id) => {
  try {
    const response = await API.get(`restaurant/standard-foods/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const createStandardFood = async (data) => {
  try {
    const response = await API.post(`restaurant/standard-foods`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};



export const updateStandardFood = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/standard-foods/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deleteStandardFood = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/standard-foods/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};